module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAeUlEQVR42u3aMQ0AIAxE0crBATP+NeCCkaQgolvfJd/Amy8yMzoXAAAAAAAAAAAAAAA0B/jLyu5epZ0xSwMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA6AXiKAgAAAAAAAAAAAADQqgfjhNmqJWf2EAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/country/nl-BE.png
// module id = tz1P
// module chunks = 1